import React, { useEffect, useState, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../mockData';

const InvestmentThesisSection = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const thesisContent = content[language].thesis;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      id="thesis" 
      ref={sectionRef}
      className="section"
      style={{ background: '#ffffff' }}
    >
      <div className="container">
        {/* Title */}
        <div className={`text-center mb-80 fade-in-up ${isVisible ? 'visible' : ''}`}>
          <h2>{thesisContent.title}</h2>
        </div>

        {/* Thesis Points */}
        <div className="grid-2" style={{ gap: '48px' }}>
          {thesisContent.points.map((point, index) => (
            <div
              key={point.title}
              className={`fade-in-up ${isVisible ? 'visible' : ''}`}
              style={{
                padding: '48px 40px',
                background: 'var(--ivory)',
                transitionDelay: `${index * 0.15}s`
              }}
            >
              <h3 
                className="mb-24" 
                style={{ 
                  fontSize: '1.5rem',
                  color: 'var(--olive)',
                  fontWeight: 500
                }}
              >
                {point.title}
              </h3>
              <p style={{ fontSize: '0.9375rem' }}>{point.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InvestmentThesisSection;
